// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { urlSettings } from "src/app/http-confing/settings/urlSettings";

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAFBqHBcx_sg7PB9v18jiOmb7EmuYZ6OUM",
    authDomain: "product-crm-6a6b1.firebaseapp.com",
    databaseURL: "https://product-crm-6a6b1.firebaseio.com",
    projectId: "product-crm-6a6b1",
    storageBucket: "product-crm-6a6b1.appspot.com",
    messagingSenderId: "1085331739287",
    appId: "1:1085331739287:web:a9697db551bda53b79cfd2",
    measurementId: "G-ENY8362QNJ",
  },
};

urlSettings.Settings = {
  // apiHost: "192.168.1.89",
  // apiEndPoint: "api",
  // apiProtocol: "http",
  // apiPort: 5000,
  apiProtocol: "https",
  apiHost: "product.leadscrm.net",
  apiEndPoint: "api",
  language: "en",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
